/**
 * Pure request builder behind `useExtensionAdmin().fetch` (HUB-103). Kept
 * hub-client-free so the node test suite can cover it. Cookies always go
 * along (`credentials: 'include'` — harmless same-origin, required
 * cross-origin; the `logo-request.ts` precedent).
 */
export function buildExtensionRequest(
  hubBaseUrl: string,
  name: string,
  path: string,
  init: RequestInit = {},
): { url: string; init: RequestInit } {
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return {
    url: `${hubBaseUrl.replace(/\/+$/, '')}/ext/${name}${suffix}`,
    init: { ...init, credentials: 'include' },
  };
}
